import React from 'react';
import cx from 'classnames';
import { PRIMARY } from '@shopee/colors';
import './style.scss';

type SpinnerPropTypes = {
  /**
   * Spinner will be shown if this is true
   */
  show?: boolean;
  /**
   * Custom color for the dots
   */
  color?: string;
  /**
   * Overlay behind spinner will not be shown if this is true
   */
  hideOverlay?: boolean;
  /**
   * Custom classname for spinner element
   */
  spinnerClassName?: string;
};

/**
 * Three dots animation imported from PC-Mall project
 * @author phamtm
 * period: 0.2s
 * from -10px to +10px
 * delay between animation: 0.1s
 * 8px radius, 6px spacing
 */
export default function Spinner({
  show = false,
  color = PRIMARY,
  hideOverlay = false,
  spinnerClassName,
}: SpinnerPropTypes) {
  return (
    <div
      className={cx(
        {
          'stardust-spinner--hidden': !show,
        },
        'stardust-spinner'
      )}
    >
      <div
        className={cx('stardust-spinner__background', {
          'stardust-spinner__background--no-overlay': hideOverlay,
        })}
      >
        <div
          className={cx(spinnerClassName, 'stardust-spinner__main')}
          role="img"
        >
          <svg width="34" height="12" viewBox="-1 0 33 12">
            <circle
              className="stardust-spinner__spinner"
              cx={4}
              cy={6}
              r={4}
              fill={color}
            />
            <circle
              className="stardust-spinner__spinner"
              cx={16}
              cy={6}
              r={4}
              fill={color}
            />
            <circle
              className="stardust-spinner__spinner"
              cx={28}
              cy={6}
              r={4}
              fill={color}
            />
          </svg>
        </div>
      </div>
    </div>
  );
}
